import { Menu } from "primereact/menu";
import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";
import { useEffect, useRef } from "react";
import MeaButton from "./MeaButton";
import { useLoadingContext } from "react-router-loading";

const MeaPage = ({
  breadcrumb,
  title,
  subtitle,
  customActions = null,
  actions = [],
  header,
  showBackButton = false,
  onBackButtonClick = null,
  isSurfaceSection = false,
  query,
  children,
}) => {
  const loadingContext = useLoadingContext();
  useEffect(() => {
    loadingContext.done();
  }, [loadingContext]);
  const actionsMenu = useRef(null);
  const filteredActions = actions.filter(item => !item.disable);

  if (query && query.isError) {
    return (<div className="p-5"><Message severity="error" text={"Error: " + query.error.message} /></div>)
  } else if (query && query.isLoading) {
    return (
      <div className="border-round border-1 surface-border p-4 surface-card">
        <div className="flex mb-3">
          <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
          <div>
            <Skeleton width="10rem" className="mb-2"></Skeleton>
            <Skeleton width="5rem" className="mb-2"></Skeleton>
            <Skeleton height=".5rem"></Skeleton>
          </div>
        </div>
        <Skeleton width="100%" height="150px"></Skeleton>
        <div className="flex justify-content-between mt-3">
          <Skeleton width="4rem" height="2rem"></Skeleton>
          <Skeleton width="4rem" height="2rem"></Skeleton>
        </div>
      </div>
    );
  } else {
    return (
      <>
        {header && <>{header}</>}
        {breadcrumb}
        <div className={`pr-2 pl-2 pb-3 pt-2 mb-3 ${isSurfaceSection ? 'surface-section' : ''}`}>
          <>
            {(title || subtitle || actions?.length > 0) && (
              <>
                <div className="flex align-items-start justify-content-between flex-row p-3">
                  <div className="flex align-items-end">
                    {showBackButton && <MeaButton
                      icon="pi pi-arrow-left"
                      text
                      style={{ minHeight: "50px", maxWidth: "50px" }}
                      onClick={onBackButtonClick || (() => window.history.back())}
                    ></MeaButton>}
                    <div>
                      <div className="font-medium text-2xl text-900">{title}</div>
                      <div className="flex align-items-center text-700 flex-wrap  mt-1 pb-2">
                        {subtitle}
                      </div>
                    </div>
                  </div>
                  <div className="flex">
                    {customActions}
                    {filteredActions.length > 0 && (
                      <div >
                        <Menu
                          model={filteredActions || []}
                          popup
                          ref={actionsMenu}
                          id="popup_actions_menu"
                        />
                        <MeaButton
                          //label="Actions"
                          text
                          raised
                          icon="pi pi-cog"
                          className="mr-2"
                          onClick={(event) => actionsMenu.current.toggle(event)}
                          aria-controls="popup_actions_menu"
                          aria-haspopup
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </>
          <div>{children}</div>
        </div>
      </>
    );
  }
};

export default MeaPage;
